// extracted by mini-css-extract-plugin
export default {"RenderWrapperTitle":"styles_RenderWrapperTitle__eKSCO","NotCropped":"styles_NotCropped__79uGW","More":"styles_More__Hnpeb"};